const prefix = "admin/division/details";

export const FETCH_DIVISION_DETAILS = `${prefix}/FETCH_DIVISION_DETAILS`;
export const FETCH_DIVISION_DETAILS_START = `${prefix}/FETCH_DIVISION_DETAILS_START`;
export const FETCH_DIVISION_DETAILS_SUCCESS = `${prefix}/FETCH_DIVISION_DETAILS_SUCCESS`;
export const FETCH_DIVISION_DETAILS_FAIL = `${prefix}/FETCH_DIVISION_DETAILS_FAIL`;

export const fetchDivisionDetails = (id) => ({
  type: FETCH_DIVISION_DETAILS,
  payload: id,
  meta: {
    thunk: true,
  },
});
